import { Camera, X } from "phosphor-react";
import React, { useEffect, useState } from "react";
import Modal from "react-responsive-modal";
import Slider from "react-slick";
import { StandardButton } from "@/components/common/StandardButton";

const SafeSlider = Slider as any;

function SampleNextArrow(props: any) {
  const { onClick } = props;
  return (
    <button
      type="button"
      className="absolute z-0 top-1/2 right-12 translate-x-1/2 -translate-y-1/2 focus-blue rounded-lg"
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
      aria-label="Next image"
    >
      <img
        className="w-8 md:w-14 h-8 md:h-14"
        src="/images/Main Icon Buttons (1).svg"
        alt=""
        aria-hidden="true"
      />
    </button>
  );
}

function SamplePrevArrow(props: any) {
  const { onClick } = props;
  return (
    <button
      type="button"
      className="absolute z-10 top-1/2 left-12 -translate-y-1/2 -translate-x-1/2 focus-blue rounded-lg"
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
      aria-label="Previous image"
    >
      <img
        className="w-8 md:w-14 h-8 md:h-14"
        src="/images/Main Icon Buttons.svg"
        alt=""
        aria-hidden="true"
      />
    </button>
  );
}

type ImageListImage = {
  id: string;
  url: string;
  username: string;
  timeAgo: string;
  note: string;
};

function ImageListViewer(props: {
  title: string;
  images: ImageListImage[];
  visible: boolean;
  currentImage: number;
  onClose: () => void;
}) {
  const [currentImage, setCurrentImage] = useState(props.currentImage);

  useEffect(() => {
    setCurrentImage(props.currentImage);
  }, [props.currentImage]);

  return (
    <Modal
      focusTrapped
      open={props.visible}
      onClose={() => props.onClose()}
      classNames={{
        root: "",
        modal: "imagelistviewer-modal",
      }}
    >
      <div className="lg:min-w-[500px] w-[calc(100vw-0px)] md:w-[calc(100vw-40px)] lg:w-[calc(40vw)] max-h-[80vh] pb-4 bg-bg-brand-secondary-default rounded-[16px] overflow-hidden">
        <div className="flex flex-row justify-between items-center px-[16px] py-[16px] border-b border-border-token-brand-minimal">
          <StandardButton
            variant="closeModal"
            onClick={props.onClose}
            tabIndex={0}
            aria-label="Close"
            className="!p-0 !bg-transparent !border-none"
          >
            <X size={24} className="!text-fg-brand-subtle" aria-hidden="true" />
          </StandardButton>
          <h3 className="text-fg-neutral-strong title-m-bold">
            {props.title}
          </h3>
          <div className="w-[24px]" />
        </div>
        <div className="p-4 w-[100%] h-[100%]">
          <SafeSlider
            dots
            dotsClass="slick-dots custom-dots"
            afterChange={(index) => {
              setCurrentImage(index);
            }}
            initialSlide={currentImage}
            nextArrow={
              props.images.length > 1 ? <SampleNextArrow /> : undefined
            }
            prevArrow={
              props.images.length > 1 ? <SamplePrevArrow /> : undefined
            }
            infinite={props.images.length > 1}
            arrows={props.images.length > 1}
          >
            {props.images.map((image) => (
              <div key={image.id} className="w-[100%] h-[100%]">
                <img
                  src={image.url}
                  alt={image.note}
                  className="rounded-[16px] object-cover max-h-[50vh] w-[100%] h-[100%] min-h-[50vh]"
                />
              </div>
            ))}
          </SafeSlider>
        </div>
        {props.images.length > 0 && (
          <div className="flex flex-col rounded-[12px] border border-primary-500 p-2 mx-[16px] mt-6">
            <div className="flex flex-row">
              <Camera
                size={24}
                className="!text-fg-brand-subtle"
                aria-hidden="true"
              />
              <p className="label-m-semibold ml-2">Photo Description</p>
              {/* <p className="text-fg-neutral-subtle ml-1">
 {props.images[currentImage].username}
 {props.images[currentImage].timeAgo ??"·" + props.images[currentImage].timeAgo}
 </p> */}
            </div>
            <p className="mt-1 label-m-semibold text-start">
              {props.images[currentImage].note}
            </p>
          </div>
        )}
      </div>
    </Modal>
  );
}

export default ImageListViewer;
